import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

const initialState = {
    alert: {},
    loading: false,
    communicationData: {},
    selectedComunication: {},
    publicContent: {},
    lastPage: {},
    notificationsUpdated: false,
    openNotificationsMenu: false,
    bookingData: {}
};

const applicationSlice = createSlice({
    name: 'application',
    initialState,
    reducers: {
        showAlert: (state, { payload }) => {
            state.alert = payload;
        },
        hideAlert: (state) => {
            return (state = {
                ...state,
                alert: {}
            });
        },
        setStorageLoading: (state, { payload }) => {
            state.loading = payload;
        },
        setNotificationsUpdated: (state, { payload }) => {
            state.notificationsUpdated = payload;
        },
        setOpenNotificationsMenu: (state, { payload }) => {
            state.openNotificationsMenu = payload;
        },
        setCommunicationData: (state, { payload }) => {
            state.communicationData = payload;
        },
        setSelectedCommunication: (state, { payload }) => {
            state.selectedComunication = payload;
        },
        setPublicContentData: (state, { payload }) => {
            state.publicContent = payload;
        },
        setLastPage: (state, { payload }) => {
            state.lastPage = payload;
        },
        setBookingData: (state, { payload }) => {
            state.bookingData = {
                ...state.bookingData,
                ...payload
            };
        }
    }
});

export default applicationSlice.reducer;

export const {
    showAlert,
    hideAlert,
    setStorageLoading,
    setCommunicationData,
    setSelectedCommunication,
    setPublicContentData,
    setNotificationsUpdated,
    setOpenNotificationsMenu,
    setLastPage,
    setBookingData
} = applicationSlice.actions;

export const selectCurrentContent = (state: RootState) => state.application.publicContent;
export const selectCurrentCommunication = (state: RootState) =>
    state.application.selectedComunication;
